const PhaseContentGroups = {
  LEFT_CONTENT: 'leftContent',
  RIGHT_CONTENT: 'rightContent',
  END_CONTENT: 'endContent'
};

export default PhaseContentGroups;
